import { render } from "./WebsitePerformance.vue?vue&type=template&id=1703518a"
import script from "./WebsitePerformance.vue?vue&type=script&lang=js"
export * from "./WebsitePerformance.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__